import React from 'react';

interface EmptyStateProps {
    icon: string;
    title: string;
    description?: string;
    action?: {
        label: string;
        onClick: () => void;
    };
    variant?: 'default' | 'compact';
}

export const EmptyState: React.FC<EmptyStateProps> = ({
    icon,
    title,
    description,
    action,
    variant = 'default'
}) => {
    const isCompact = variant === 'compact';

    return (
        <div className={`flex flex-col items-center justify-center text-center ${isCompact ? 'py-8 px-4' : 'py-16 px-6'}`}>
            <div className={`${isCompact ? 'text-4xl mb-2' : 'text-6xl mb-4'} opacity-30`}>
                {icon}
            </div>
            <h3 className={`${isCompact ? 'text-sm' : 'text-lg'} font-semibold text-slate-700`}>
                {title}
            </h3>
            {description && (
                <p className={`${isCompact ? 'text-xs' : 'text-sm'} text-slate-500 mt-1 max-w-md`}>
                    {description}
                </p>
            )}
            {action && (
                <button
                    onClick={action.onClick}
                    className="mt-4 px-4 py-2 text-sm font-medium bg-gradient-to-r from-blue-600 to-indigo-600 text-white rounded-lg hover:from-blue-700 hover:to-indigo-700 transition-all shadow-sm hover:shadow"
                >
                    {action.label}
                </button>
            )}
        </div>
    );
};

export default EmptyState;